import type { TFunction } from 'i18next';
import {
  getTranslation as createScopedTranslation,
  type CustomTFunction as GenericCustomTFunction,
  type TranslationNestedKey as GenericNestedKey,
  type TranslationResult as GenericResult,
  type RemoveCount,
} from '@nexelem/services';
import type { Translation } from '../../../translations/generic/pl';

export type { RemoveCount };

/**
 * Catalog path. Kept as `string` so call sites do not instantiate a union of
 * every nested translation key (that was the main tsc hotspot).
 */
export type TranslationPath = string;

export type CustomTFunction = GenericCustomTFunction<Translation>;

export type TranslationNestedKey<T extends string = string> = GenericNestedKey<Translation, T>;

export type TranslationResult<T extends string = string> = GenericResult<Translation, T>;

export const getTranslation = <T extends string>(t: TFunction | CustomTFunction, base: T): TranslationResult<T> =>
  createScopedTranslation<Translation, T>(t, base);
